import axios from "axios";
import { isEmpty } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, Col, Row, Table, UncontrolledCollapse } from "reactstrap";
import { apiBaseUrl } from "../../configs/configs";

const OpinionTradingDetails = (props) => {
    const { trade_id } = props.match.params
    const [data, setData] = useState([])

    useEffect(() => {
        setDetails()
    }, [])

    const setDetails = async () => {
        const result = await axios.get(`${apiBaseUrl}/trade_details/trade/${trade_id}`);
        console.log(result, "---result")
        if (result.data.status === 'success') {
            setData(result.data.data)
        }
    }

    const joinDetails = (data) => {
        var a = ['', 'one ', 'two ', 'three ', 'four ', 'five ', 'six ', 'seven ', 'eight ', 'nine ', 'ten ', 'eleven ', 'twelve ', 'thirteen ', 'fourteen ', 'fifteen ', 'sixteen ', 'seventeen ', 'eighteen ', 'nineteen '];
        var b = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        function inWords(num) {
            if ((num = num.toString()).length > 9) return 'overflow';
            var n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
            if (!n) return; var str = '';
            str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
            str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
            str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
            str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
            str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + '' : '';
            return str;
        }

        const joinDetails = data.joined_detail
        const dataOfArray = []
        Object.keys(joinDetails).map(function (key) {
            dataOfArray.push(joinDetails[key])
        });
        const one = dataOfArray.map((data, index) => {
            console.log()
            return <>
                <Table>
                    <tr>
                        <th>opt_{data.id}_{isEmpty(inWords(data.slot_fee)) ? data.slot_fee : inWords(data.slot_fee)}</th>
                        <td>Id:{data.id}</td>
                        <td>Slot :{data.slots}</td>
                        <td>Slot Fee :{data.slot_fee}</td>
                    </tr>
                </Table>
            </>
        })
        return one
    }

    const joinedMatch = (data) => {
        const joinedData = data.joined_match
        console.log(Object.keys(joinedData)[0])
        return <Table>
            <tr>
                <td>{Object.keys(joinedData)[0]} : {Object.values(joinedData)[0]}</td>
                <td>{Object.keys(joinedData)[1]} : {Object.values(joinedData)[1]}</td>
            </tr>
        </Table>
    }

    const tradingStyle = {
            display: "flex",
            justifyContent: "space-between",
            listStyle: "none",
            marginBottom:"0px"
    }
    return (
        <>
            <div className="animated fadeIn">
                <Row>
                    <Col xl={12}>
                        <Card>
                            <CardHeader>
                                <i className="fa fa-align-justify"></i>Opinion Trading Details<small className="text-muted"></small>
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    {
                                        !isEmpty(data) ? data.map((data, index) =>

                                            <>
                                                <Button
                                                    color="primary"
                                                    id={'data'+index}
                                                    // id={data.prediction_id.toString()}
                                                    style={{
                                                        width: "100%",
                                                        marginBottom: '1rem'
                                                    }}
                                                >
                                                    <ul style={tradingStyle}>
                                                        <li>Id :- {data._id}</li>
                                                        <li>User Id :- {data.user_id}</li>
                                                    </ul>
                                                </Button>
                                                <UncontrolledCollapse toggler={'#data'+index} style={{width:"100%"}}>
                                                    <Table>
                                                        <tr>
                                                            <th>Created At</th>
                                                            <td>{moment(data.createdAt).format('YYYY-MM-DD')}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Match Id</th>
                                                            <td>{data.match_id}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Series Id</th>
                                                            <td>{data.series_id}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Question</th>
                                                            <td>{data.question_english}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Refund Cash Amount</th>
                                                            <td>{data.refund_cash_amount}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Refund Win Amount</th>
                                                            <td>{data.refund_win_amount}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Total Cash</th>
                                                            <td>{data.total_cash}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Total Matched</th>
                                                            <td>{data.total_matched}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Total Slot</th>
                                                            <td>{data.total_slot}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Total Wining</th>
                                                            <td>{data.total_wining}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Win Distribute</th>
                                                            <td>{data.win_distribute ? "Distributed" :'Not Distributed'}</td>
                                                        </tr>
                                                        <tr>
                                                            <th>Win Reward</th>
                                                            <td>{data.win_reward}</td>
                                                        </tr>
                                                    </Table>
                                                </UncontrolledCollapse>
                                            </>

                                        ) : 'No Data found'
                                    }
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}

export default OpinionTradingDetails